import React, { useEffect, useState } from 'react'
import { TouchableOpacity, View, ViewStyle, Image, ImageStyle, Platform } from 'react-native'
import { color } from '../../theme'
import { Text } from '../text'
import { Badge, useStores } from '@trivie/core'
import { IMSTArray } from 'mobx-state-tree'
import { Card } from '../card'

interface UserBadgesProps {
  badges: IMSTArray<typeof Badge>
  loading?: boolean
  goToBadge?: any
}

export const UserBadges = (props: UserBadgesProps) => {
  const { badges = [], goToBadge } = props

  const { userStore } = useStores()
  const { user } = userStore

  const [badgeItems, setBadgeItems] = useState<any>([])

  useEffect(() => {
    let allItems = badges.slice()
    if (!user?.workspace_settings?.feed_enabled) {
      allItems = allItems.filter(
        (f) =>
          !(
            f.description.toLowerCase().includes('reply') ||
            f.description.toLowerCase().includes('post')
          ),
      )
    }
    setBadgeItems(
      allItems.filter((b: any) => {
        if (b.is_custom && !b.awarded_at) {
          return false
        }
        return true
      }),
    )
  }, [badges])

  const renderBadges = () => {
    const result = badgeItems.map((item, index: number) => {
      return (
        <TouchableOpacity
          // @ts-ignore
          dataSet={{ qat: `badge_${item.badge_id}` }}
          onPress={() => goToBadge(item)}
          key={`key_badge_${item.badge_id}`}
          style={{
            display: 'flex',
            flexDirection: 'row',
            paddingTop: 10,
            paddingBottom: 10,
            opacity: item.awarded_at ? 1 : 0.3,
          }}
        >
          <Image style={BADGE_IMG} source={{ uri: item?.icon_url || '-' }} />

          <View
            style={{
              flex: 1,
              justifyContent: 'center',
              paddingLeft: 15,
            }}
          >
            <Text text={`${item.label}`} variant="body1Emphasized" />
            <Text
              text={item.description}
              variant="body2Emphasized"
              style={{ color: color.shade50 }}
            />
          </View>
        </TouchableOpacity>
      )
    })
    return result
  }

  return (
    <Card
      style={{ alignItems: undefined, padding: 0, justifyContent: 'flex-start', height: 'auto' }}
    >
      <View style={VIEW_CARD}>
        <Text
          style={{ color: '#9098A3' }}
          uppercase
          tx="Profile.badges"
          variant="body2Emphasized"
        />
        <View
          style={{
            marginTop: 10,
            borderBottomColor: '#F0F2F5',
            borderBottomWidth: 1,
          }}
        />
        <View style={{ paddingTop: 10 }}>{renderBadges()}</View>
      </View>
    </Card>
  )
}

const VIEW_CARD: ViewStyle = {
  paddingHorizontal: 18,
  paddingVertical: 12,
  backgroundColor: '#fff',
  marginBottom: 16,
  padding: 20,
  borderRadius: 20,
}
const BADGE_IMG: ImageStyle = {
  height: 48,
  width: 48,
  alignSelf: 'center',
  borderRadius: 50,
}
